import { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";

import PaginationWithControls from "../PaginationWithControls";

interface PageUrlCategory {
  categoryId: number;
  categoryName: string;
}
interface ListPageUrlCategoryProps {
  pageUrlCategoryList: PageUrlCategory[];
  resetFindOptions: () => void;
  findOptions: any;
  handleFind: (findOptions: any) => void;
  handelDelete: (categoryId: number) => void;
  handelEdit: (state: {}) => void;
  totalItemCount: number;
  pageIndex: number;
  pageSize: number;
  onChangePageIndex: (pageNumber: number) => void;
  onChangePageSize: (pageSize: number) => void;
}

const ListPageUrlCategory: React.FC<ListPageUrlCategoryProps> = ({
  pageUrlCategoryList,
  resetFindOptions,
  findOptions,
  handleFind,
  handelDelete,
  totalItemCount,
  pageIndex,
  pageSize,
  onChangePageIndex,
  handelEdit,
  onChangePageSize,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [searchOptions, setSearchOptions] = useState(findOptions);

  const handleModalOpen = () => setShowModal(true);
  const handleModalClose = () => setShowModal(false);
  const handelClearParameter = () => {
    setSearchOptions({
      stateId: 0,
      CategoryId: 0,
    });
    resetFindOptions();
  };

  const onChangeFieldValue = (value: object) => {
    setSearchOptions({ ...searchOptions, ...value });
  };
  const onClickFind = (findOptions: any) => {
    handleFind(findOptions);
    handleModalClose();
  };

  return (
    <>
      <div className="float-end">
        <Button
          variant="primary"
          className="ml-1 mb-3"
          onClick={handleModalOpen}
        >
          Find Options
        </Button>
        <Modal show={showModal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Find Categories</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Button
              className="mb-3"
              variant="secondary"
              onClick={() => handelClearParameter()}
            >
              Clear Parameters
            </Button>
            <Form>
              <Form.Group className="mb-3" controlId="find-category">
                <Form.Label>categoryName</Form.Label>
                <Form.Control
                  type="text"
                  value={
                    searchOptions.categoryName ? searchOptions.categoryName : ""
                  }
                  onChange={(e) =>
                    onChangeFieldValue({ categoryName: e.target.value })
                  }
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => onClickFind(searchOptions)}
            >
              Find
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {pageUrlCategoryList.map(
            (pageUrlCategory: PageUrlCategory, index: number) => (
              <tr key={index}>
                <td>{pageUrlCategory.categoryId}</td>
                <td>{pageUrlCategory.categoryName}</td>
                <td>
                  <Button onClick={() => handelEdit(pageUrlCategory)}>
                    Edit
                  </Button>
                </td>
                <td>
                  <Button
                    variant="danger"
                    onClick={() => handelDelete(pageUrlCategory?.categoryId)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            )
          )}
        </tbody>
      </Table>
      {pageUrlCategoryList.length > 0 ? (
        <>
          <PaginationWithControls
            pageIndex={pageIndex}
            pageSize={pageSize}
            listCount={totalItemCount}
            onChangePageIndex={onChangePageIndex}
            onChangePageSize={onChangePageSize}
          />
        </>
      ) : (
        <p className="text-center py-3">No results found</p>
      )}
    </>
  );
};

export default ListPageUrlCategory;
